/**
 * Sort Algolia items based on a prefered order, when not
 * present in the prefered order array, the values get
 * ordered on alfabetical order
 *
 * @param {Array with prefered order} preferedOrder
 * @param {Incoming array} items
 * @returns
 */
export const sortOnPreferedOrder = (preferedOrder, items) =>
  items.sort((a, b) => {
    let preferedA = preferedOrder.indexOf(a.value);
    let preferedB = preferedOrder.indexOf(b.value);

    // First based on refinement
    if (a.isRefined && b.isRefined) {
      return 0;
    } else if (a.isRefined && !b.isRefined) {
      return -1;
    } else if (!a.isRefined && b.isRefined) {
      return 1;
    } else if (preferedA !== -1 && preferedB !== -1) {
      // Then based on prefered sort
      if (preferedA === preferedB) return 0;
      else if (preferedA > preferedB) return 1;
      else return -1;
    } else if (preferedA != -1 && preferedB == -1) {
      return -1;
    } else if (preferedA == -1 && preferedB !== -1) {
      return 1;
    } else {
      // Otherwise based on count
      return b.count - a.count;
    }
  });
